import { render, staticRenderFns } from "./EnChosuiBandChart.vue?vue&type=template&id=fa37f4f0&scoped=true"
import script from "./EnChosuiBandChart.vue?vue&type=script&lang=ts"
export * from "./EnChosuiBandChart.vue?vue&type=script&lang=ts"
import style0 from "./EnChosuiBandChart.vue?vue&type=style&index=0&id=fa37f4f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa37f4f0",
  null
  
)

export default component.exports